import { unref } from "vue";
const unwrapEl = (el) => {
  if (!el) {
    return;
  }
  if (typeof el !== "object") {
    return;
  }
  el = unref(el);
  if (!el) {
    return;
  }
  if (typeof el.$el !== "undefined") {
    return el.$el;
  }
  return el;
};
export {
  unwrapEl as u
};
//# sourceMappingURL=unwrapEl.js.map
